export const ERROR_MESSAGE = "error";

export const KEY_ENTER = "Enter";
export const KEY_TAB = "Tab";
export const KEY_SPACE = " ";
export const KEY_ESC = "Escape";

export const ITEM_DEADLINE_BLANK = "none";

export const REMINDER_TYPE_NONE = 0;
export const REMINDER_TYPE_RELATIVE = 1;
export const REMINDER_TYPE_DATE = 2;
export const REMINDER_BEFORE = "b";
export const REMINDER_AFTER = "a";
export const REMINDER_START = "s";
export const REMINDER_END = "e";
export const FORM_REMINDERDATE = "reminderDate";
export const FORM_REMINDERTYPE = "reminderType";
export const FORM_RELATIVEREMINDER = "relativeReminder";
export const FORM_RELATIVEREMINDERDATE = "relativeReminderDate";
export const FORM_EMAILADDRESSES = "emailAddresses";
export const FORM_SUBJECT = "subject";
export const FORM_RECEIVERS = "receivers";

export const TABLE_COLUMN_SELECT = "select";
export const TABLE_COLUMN_TITLE = "title";
export const TABLE_COLUMN_DESCRIPTION = "description";
export const TABLE_COLUMN_DEADLINE = "deadline";
export const TABLE_COLUMN_REMINDER = "reminder";
export const TABLE_COLUMN_COMPLETED = "completed";
export const TABLE_COLUMN_CREATEDBY = "created";
export const TABLE_COLUMN_LASTMODIFIED = "lastmodified";

export const TABLE_ROW_ACTION_EDIT = "edit";
export const TABLE_ROW_ACTION_DELETE = "delete";
export const TABLE_ROW_ACTION_COPY = "copy";
